export default __webpack_public_path__ + "static/media/100_desktop.558ded2d.jpg";